import { render, staticRenderFns } from "./Sending.vue?vue&type=template&id=7d88924c"
import script from "./Sending.vue?vue&type=script&lang=js"
export * from "./Sending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports